import { adminGet, adminPost, adminPut, adminDelete } from './admin-ajax'

// ==================== System Skills Types ====================

export interface SystemSkillCategory {
  id: string
  name: string
  icon: string | null
  sort_order: number | null
  is_active: boolean
  item_count: number
  created_at: string | null
  updated_at: string | null
}

export interface SystemSkillItem {
  id: string
  category_id: string
  category_name: string | null
  category_icon: string | null
  name: string
  summary: string | null
  content_md: string
  sort_order: number | null
  is_active: boolean
  created_at: string | null
  updated_at: string | null
}

// ==================== User Skills Types ====================

export interface UserSkillSummary {
  user_id: string
  username: string | null
  email: string | null
  category_count: number
  item_count: number
}

export interface UserSkillItem {
  id: string
  category_id: string
  category_name: string | null
  category_icon: string | null
  name: string
  summary: string | null
  content_md: string
  is_system_default: boolean
  created_at: string | null
  updated_at: string | null
}

// ==================== System Skills API ====================

export const listSystemCategories = (params?: { include_inactive?: boolean }) =>
  adminGet<{ success: boolean; items: SystemSkillCategory[] }>('/api/admin/skills/system/categories', params)

export const createSystemCategory = (data: { name: string; icon?: string | null; sort_order?: number }) =>
  adminPost<{ success: boolean; data: SystemSkillCategory }>('/api/admin/skills/system/categories', data)

export const updateSystemCategory = (id: string, data: { name?: string; icon?: string | null; sort_order?: number; is_active?: boolean }) =>
  adminPut<{ success: boolean; data: SystemSkillCategory }>(`/api/admin/skills/system/categories/${id}`, data)

export const deleteSystemCategory = (id: string) =>
  adminDelete<{ success: boolean; message: string }>(`/api/admin/skills/system/categories/${id}`)

export const listSystemItems = (params?: { category_id?: string; include_inactive?: boolean }) =>
  adminGet<{ success: boolean; items: SystemSkillItem[] }>('/api/admin/skills/system/items', params)

export const createSystemItem = (data: { category_id: string; name: string; summary?: string; content_md: string; sort_order?: number }) =>
  adminPost<{ success: boolean; data: SystemSkillItem }>('/api/admin/skills/system/items', data)

export const updateSystemItem = (id: string, data: { category_id?: string; name?: string; summary?: string; content_md?: string; sort_order?: number; is_active?: boolean }) =>
  adminPut<{ success: boolean; data: SystemSkillItem }>(`/api/admin/skills/system/items/${id}`, data)

export const deleteSystemItem = (id: string) =>
  adminDelete<{ success: boolean; message: string }>(`/api/admin/skills/system/items/${id}`)

export const importDefaultTemplates = () =>
  adminPost<{ success: boolean; categories_created: number; items_created: number }>('/api/admin/skills/system/import_defaults', {})

// ==================== User Skills API ====================

export const listUsersWithSkills = (params?: { page?: number; page_size?: number }) =>
  adminGet<{ success: boolean; items: UserSkillSummary[]; total: number; page: number; page_size: number; total_pages: number }>(
    '/api/admin/skills/users',
    params
  )

export const listUserSkillItems = (userId: string) =>
  adminGet<{ success: boolean; items: UserSkillItem[] }>(`/api/admin/skills/users/${userId}/items`)
